import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ViewSProviderProfile from "../../../components/SidetabPages/ServiceProvider/ViewSProviderProfile";

const ServiceProviderProfile = () => {
  return (
    <>
      <AnnouncementBar />
      <ViewSProviderProfile />
    </>
  );
};
export default ServiceProviderProfile;
